import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { getFormattedDateTime } from '../../../helpers/DateTime';

import EmptyTableCell from '../../EmptyTableCell';

const AdminUploadPageUploadsListItem = ({ upload }) => {
  const intl = useIntl();

  return (
    <tr>
      <th scope="row" className="upload-page-upload-uuid">
        <Link to={`/uploads/${upload.uuid}`} title="View files" target="_blank">
          {upload.uuid}
        </Link>
      </th>
      <td className="upload-page-upload-files">
        <Link to={`/uploads/${upload.uuid}`} title="View files" target="_blank">
          {upload.files_count}
        </Link>
      </td>
      <td className="upload-page-upload-name">
        {upload.name || <EmptyTableCell />}
      </td>
      <td className="upload-page-upload-email">
        {upload.email || <EmptyTableCell />}
      </td>
      <td className="upload-page-upload-created-at">
        {getFormattedDateTime(upload.created_at)}
      </td>
      <td className="action-more">
        <Link id={`upload-${upload.uuid}`} to={`/uploads/${upload.uuid}`} target="_blank">
          <i className="fa-regular fa-file" />
        </Link>
        <UncontrolledTooltip target={`upload-${upload.uuid}`} fade={false}>
          {intl.formatMessage({ defaultMessage: 'View files' })}
        </UncontrolledTooltip>
      </td>
    </tr>
  );
};

AdminUploadPageUploadsListItem.propTypes = {
  upload: PropTypes.object.isRequired,
};

export default AdminUploadPageUploadsListItem;
